import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Fia } from '../shared/models/users/fia';
import { UserFiaPins } from '../shared/models/users/user-fia-pins';
import { MediaInfo } from '../shared/models/general/media-info';
import { UserFiaPinDocument } from '../shared/models/users/user-fia-pin-document';
import { FiaLeftToApplyFor } from '../shared/models/users/fia-left-to-apply-for';
import { DooyaFiaApplication } from '../shared/models/users/dooya-fia-application';

@Injectable({
  providedIn: 'root',
})
export class FiaService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/fia/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public FiaApplcation(fia: Fia): Observable<any> {
    return this.http.post<any>(this.apiUrl + 'application', fia, { observe: 'response' }).pipe(
      map((res) => {
        if (res) {
          if (res.status == 200) {
            return new Fia().deserialize(res.body);
          }
        }
      })
    );
  }

  public CreateFiaPin(fiaPin: UserFiaPins): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + `create-fia-pin/`, fiaPin, {
        observe: 'response',
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return new UserFiaPins().deserialize(res.body);
            }
          }
        })
      );
  }

  public CalculateLeftToApplyFor(userId: number): Observable<FiaLeftToApplyFor> {
    return this.http
      .get<FiaLeftToApplyFor>(this.apiUrl + 'application/calculate-left-to-apply-for/' + userId, {
        observe: 'response',
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return new FiaLeftToApplyFor().deserialize(res.body);
            }
          }
        })
      );
  }

  public UpdateFiaPin(fiaPin: UserFiaPins): Observable<any> {
    return this.http.put<any>(this.apiUrl + 'update-fia-pin', fiaPin, { observe: 'response' }).pipe(
      map((res) => {
        if (res) {
          if (res.status == 200) {
            return new UserFiaPins().deserialize(res.body);
          }
        }
      })
    );
  }

  public ValidateFiaPinDocument(media: MediaInfo): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + 'validate-fia-pin-document', media, {
        observe: 'response',
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return new UserFiaPinDocument().deserialize(res.body);
            }
          }
        })
      );
  }

  public GetDooyaFiaData(externalId: number): Observable<DooyaFiaApplication> {
    return this.http.get<DooyaFiaApplication>(`${this.apiUrl}application/externalData/${externalId}`);
  }
}
